import { render, staticRenderFns } from "./Document-report-table.vue?vue&type=template&id=6eea86fc&scoped=true"
import script from "./Document-report-table.vue?vue&type=script&lang=js"
export * from "./Document-report-table.vue?vue&type=script&lang=js"
import style0 from "./Document-report-table.vue?vue&type=style&index=0&id=6eea86fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eea86fc",
  null
  
)

export default component.exports